import { Injectable } from '@angular/core';
import { BaseApiService } from '../base-api.service';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { BuildingBlockPurpose } from '../../models/building-blocks/building-block-purpose.model';
import { BuildingBlockSubType } from '../../models/building-blocks/building-block-sub-type.model';
import { BuildingBlockBinauralBeatsFrequencyVariation } from '../../models/building-blocks/building-block-binaural-beats-frequency-variation.model';
import { BuildingBlockBinauralBeatsSoundType } from '../../models/building-blocks/building-block-binaural-beats-sound-type.model';
import { environment } from '@beyou/environments/environment';
import { CategorizationsResponse } from '../../dto/categorizations-response';
import { BuildingBlockSubTypeMapper } from '../../mappers/building-blocks/building-block-sub-type.mapper';
import { BuildingBlockCategoryMapper } from '../../mappers/building-blocks/building-block-category.mapper';
import { EnumMapper } from '../../mappers/enum.mapper';
import { BuildingBlockCategory } from '../../models/building-blocks/building-block-category.model';
import { TimeSlotMapper } from '../../mappers/time-slot.mapper';
import { ProgramTemplateIntensityLevel } from '../../models/programs/program-template-intensity-level.model';
import { ProgramTemplateSessionFrequency } from '../../models/programs/program-template-session-frequency.model';
import { TimeSlot } from '../../models/time-slot.model';

export type Categorizations = {
  buildingBlockPurposes: BuildingBlockPurpose[],
  buildingBlockSubTypes: BuildingBlockSubType[],
  buildingBlockBinauralBeatsFrequencyVariations: BuildingBlockBinauralBeatsFrequencyVariation[],
  buildingBlockBinauralBeatsSoundTypes: BuildingBlockBinauralBeatsSoundType[],
  buildingBlockCategories: BuildingBlockCategory[],
  programTemplateIntensityLevels: ProgramTemplateIntensityLevel[],
  programTemplateSessionFrequencies: ProgramTemplateSessionFrequency[],
  timeSlots: TimeSlot[]
}

@Injectable({
  providedIn: 'root'
})
export class CategorizationApiService extends BaseApiService {

  constructor(http: HttpClient) { 
    super(http);
  }

  public getCategorizations(): Observable<Categorizations> {
    const apiUrl = `${environment.adminApiBaseUrl}/categorizations`;
    return this.http.get<CategorizationsResponse>(apiUrl).pipe(
      map(response => {
        // Titles are translation keys (`shared.enums.*`); the 'all' purpose reads "Both empowerment & exploration" there.
        const buildingBlockPurposes = response.building_block_purposes.map(item => EnumMapper.toModel<BuildingBlockPurpose>(item, 'buildingBlockPurposes'));

        const buildingBlockCategories = response.building_block_categories.map(item => BuildingBlockCategoryMapper.toModel(item));
        const buildingBlockSubTypes = response.building_block_sub_types.map(item =>  BuildingBlockSubTypeMapper.toModel(item));
        const buildingBlockBinauralBeatsFrequencyVariations = response.building_block_binaural_beats_frequency_variations.map(item => EnumMapper.toModel<BuildingBlockBinauralBeatsFrequencyVariation>(item, 'binauralFrequencyVariations'));
        const buildingBlockBinauralBeatsSoundTypes = response.building_block_binaural_beats_sound_types.map(item => EnumMapper.toModel<BuildingBlockBinauralBeatsSoundType>(item, 'binauralSoundTypes'));
        const programTemplateIntensityLevels = response.program_intensity_levels.map(item => EnumMapper.toModel<ProgramTemplateIntensityLevel>(item, 'programIntensityLevels'));
        const programTemplateSessionFrequencies = response.program_session_frequencies.map(item => EnumMapper.toModel<ProgramTemplateSessionFrequency>(item, 'programSessionFrequencies'));
        const timeSlots = response.time_slots.map(item => TimeSlotMapper.toModel(item));
        
        return {
          buildingBlockPurposes,
          buildingBlockSubTypes,
          buildingBlockBinauralBeatsFrequencyVariations,
          buildingBlockBinauralBeatsSoundTypes,
          buildingBlockCategories,
          programTemplateIntensityLevels,
          programTemplateSessionFrequencies,
          timeSlots
        };
      })
    );
  }
}
